export const BASE_ASSETS = `${process.env.PUBLIC_URL}/assets/img`;
export const LOGO_ALEATICA_CRASH = `${BASE_ASSETS}/logo_aleatica_crash_birds.png`;
export const DEFAULT_USER_IMAGE = `${BASE_ASSETS}/users/default2.jpg`;
export const IMG_WHITE_LOGO = `${BASE_ASSETS}/aleatica_logo_blanco.png`;
export const IMG_LOGO = `${BASE_ASSETS}/aleatica_logo.png`;
export const IMG_LOGO_MINI = `${BASE_ASSETS}/logo-aleatica-mini.png`;
export const DEFAULT_BACK = `${BASE_ASSETS}/defaultBack.jpg`;
export const DEFAULT_IMAGE = `${BASE_ASSETS}/default-image.png`;
export const HEADER_IMAGE = `${BASE_ASSETS}/header.png`;
export const EXCEL_ICON = `${BASE_ASSETS}/excel-icon.png`;
export const SOCIETY_BG = `${BASE_ASSETS}/aleatica-logo-bg.jpg`;
export const AREA_BG = `${BASE_ASSETS}/aleatica-logo-bg.jpg`;
export const LOGO_VERTICAL = `${BASE_ASSETS}/logo_vertical.png`;
export const LOGO_HORIZONTAL = `${BASE_ASSETS}/logo_horizontal.png`;
export const LOGO_HORIZONTAL_2 = `${BASE_ASSETS}/bannerlogo.png`;
export const IMG_BG = `${BASE_ASSETS}/bg.jpg`;
export const IMG_BG1 = `${BASE_ASSETS}/bg1.jpg`;
export const IMG_BG2 = `${BASE_ASSETS}/bg2.jpg`;
export const IMG_BG3 = `${BASE_ASSETS}/bg3.jpg`;
export const IMG_BG4 = `${BASE_ASSETS}/bg4.jpg`;
export const IMG_BG5 = `${BASE_ASSETS}/bg5.jpg`;
export const IMG_INTEGRIDAD = `${BASE_ASSETS}/integridad.png`;
export const IMG_EXCELENCIA = `${BASE_ASSETS}/excelencia.png`;
export const IMG_SEGURIDAD = `${BASE_ASSETS}/seguridad.png`;
export const IMG_SOSTENIBILIDAD = `${BASE_ASSETS}/sostenibilidad.png`;
export const IMG_EQUIPO = `${BASE_ASSETS}/equipo.png`;
export const IMG_PEAJE = `${BASE_ASSETS}/peaje.png`;
export const IMG_OFFICE_365 = `${BASE_ASSETS}/office365.png`;
export const IMG_BLOB = `${BASE_ASSETS}/blob-naranja-y-verde.png`;
export const IMG_LEGAL = `${BASE_ASSETS}/legal.png`;
